var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modalContents__object12" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row no-gutters" }, [
        _c(
          "div",
          { staticClass: "col-lg-7 col-md-8 col-10 mx-auto row no-gutters" },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-8 mx-auto" }, [
              _c(
                "span",
                { staticClass: "text-center", on: { click: _vm.hideModal } },
                [_vm._v("閉じる")]
              )
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "col-12 text-center" }, [
      _vm._v("お問い合わせありがとうございます。\n          "),
      _c("br"),
      _vm._v(
        "弊社スタッフが内容を確認しましたら折り返し連絡いたします。\n        "
      )
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18b0ea17", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18b0ea17","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/vue/component/modal/contact_thanks.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-18b0ea17","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/vue/component/modal/contact_thanks.vue
// module chunks = 0